import './App.css';
import Conversation from './components/Conversation';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import { useEffect } from "react"


import { Link } from 'react-router-dom';
function App() {
  useEffect(() => {
    document.title = "KPOINT Catalyst (Nov - Dec)";
  }, [])
  return (
    <div>
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Conversation" element={<Conversation />} />
      </Routes>
    </Router>

    </div>
  );
}

export default App;
